import { createElementBlock as l, openBlock as o, createElementVNode as n } from "vue";
const r = {
  viewBox: "0 0 44 44",
  class: "fa-anchorIcon",
  xmlns: "http://www.w3.org/2000/svg",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  "stroke-linejoin": "round",
  "stroke-miterlimit": "2"
};
function t(c, e) {
  return o(), l("svg", r, e[0] || (e[0] = [
    n("path", {
      d: "M24.955 31.31l12.77-12.476a.569.569 0 0 1 .782 0l3.131 3.062a.532.532 0 0 1 0 .763l-16.3 15.924-3.131 3.058a.562.562 0 0 1-.783 0L2.326 22.986a.532.532 0 0 1 0-.763l3.131-3.062a.569.569 0 0 1 .783 0l12.77 12.476V2.825c0-.364.297-.66.66-.66h4.624c.363 0 .66.296.66.66V31.31z",
      fill: "#fc0",
      "fill-rule": "nonzero"
    }, null, -1)
  ]));
}
const a = { render: t };
export {
  a as default,
  t as render
};
